import { FeatureMainProps } from '../../../../components/Features/FeatureMain/types'

export const pageData: FeatureMainProps = {
    accentColor: '#B60000',
    pc: {
        background: '/features/ings-20260721/pc_bg.jpg',
        overlay:
            'linear-gradient(180deg, rgba(200, 161, 63, 0.85), rgba(217, 137, 0, 0.85))',
        eyebrow: '求人特集',
        titleLines: ['株式会社', 'INGS'],
        titleFont: 'sans-serif',
        contentsColor: '#B60000',
    },
    hero: {
        image: '/features/ings-20260721/hero.jpg',
        alt: '株式会社INGS',
        analyticsLabel: 'FV',
    },
    headline: {
        eyebrow: [
            { text: '人', accent: true },
            { text: 'と' },
            { text: '料理', accent: true },
            { text: 'と' },
            { text: '空間', accent: true },
            { text: 'で' },
        ],
        title: [
            { text: '幸せ', accent: true, fontSize: '34px' },
            { text: 'になれる', fontSize: '34px' },
            { text: '場所', accent: true, breakBefore: true, fontSize: '34px' },
            { text: 'をつくる', fontSize: '34px' },
            { text: '。', hangEnd: true, fontSize: '34px' },
        ],
        paragraphs: [
            { text: '「自分のために働く。」' },
            { text: '会社のためではなく、', breakBefore: true },
            { text: '自分のために一生懸命やるほど', breakBefore: true },
            { text: '幸せな人が増えていく。', breakBefore: true },
            { text: 'それがＩＮＧＳの考え方です。', breakBefore: true },
        ],
    },
    thumbnail: {
        image: '/features/ings-20260721/top_sub.jpg',
        alt: '株式会社INGS',
    },
    featuresTitle: ['INGSで働く魅力'],
    featuresTitleAnalyticsLabel: 'CT_Charm_働く魅力-タイトル',
    features: [
        {
            heading: [
                '10ブランド展開、',
                '東証グロース市場上場の',
                '安定基盤と労働環境',
            ],
            body: [
                '2009年の創業以来、1都3県を中心に出店を重ね、2024年9月には東証グロース市場へ上場。安定した会社基盤の上で、長く働き続けられます。',
            ],
            image: '/features/ings-20260721/section_01.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-1st',
        },
        {
            heading: ['100人いたら100人が満足できる「地域一番店」'],
            body: [
                '老若男女どんなお客様にも満足してもらえる「地域一番店」をつくりたいからこそ、味、人、空間、どれも高いレベルで提供することをINGSは当たり前としています。',
            ],
            image: '/features/ings-20260721/section_02.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-2nd',
        },
        {
            heading: ['年10店舗以上展開で', '挑戦機会が自然と生まれる環境'],
            body: [
                '新卒入社から2年経たずに店長になる人、25歳でマネージャーになる人も。昇給のチャンスは年3回。頑張りがそのままスピード昇格につながります。',
            ],
            image: '/features/ings-20260721/section_03.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-3rd',
        },
    ],
    floatingCta: {
        label: '求人一覧を見る',
        analyticsLabel: 'CT_Jobinformation_追従CTA',
    },
    jobs: {
        eyebrow: 'pickup',
        title: ['INGS 求人特集'],
        analyticsLabel: 'CT_Jobinformation_求人特集-タイトル',
        categories: [
            {
                id: 'ramen',
                categoryLabel: 'ラーメン事業部',
                description:
                    '「らぁ麺はやし田」はじめ、家系・油そばなど9ブランドを1都3県と大阪・仙台で展開。商品開発力を活かした多ブランド展開が強み',
                jobs: [
                    {
                        offerId: '120929',
                        badgeLabel: 'ラーメン | ホールスタッフ',
                        title: '【未経験歓迎＊昇給年3回★月9日休み】綺麗な店舗＊百名店にも選ばれた人気店',
                        brandName: 'らぁ麺 はやし田 上野御徒町店',
                        brandLogo: '/features/ings-20260721/logo_ramen.png',
                        salary: '27~35',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '台東区',
                        image: '/features/ings-20260721/job_card_ramen_01.jpg',
                        href: 'https://foods-labo.com/offers/120929',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ラーメン事業部-1st',
                    },
                    {
                        offerId: '58982',
                        badgeLabel: 'ラーメン | キッチンスタッフ',
                        title: '＼1回1万円昇給チャンス×年3回！／未経験も歓迎★大人気ラーメン店',
                        brandName: 'らぁ麺 はやし田 風仙花',
                        brandLogo: '/features/ings-20260721/logo_ramen.png',
                        salary: '27~35',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '新宿区',
                        image: '/features/ings-20260721/job_card_ramen_02.jpg',
                        href: 'https://foods-labo.com/offers/58982',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ラーメン事業部-2nd',
                    },
                    {
                        offerId: '58960',
                        badgeLabel: 'ラーメン | キッチンスタッフ',
                        title: '【月給27万円～＊昇給3回★ラーメン好き大歓迎】はやし田の正社員を募集！',
                        brandName: 'らぁ麺 はやし田 道頓堀店',
                        brandLogo: '/features/ings-20260721/logo_ramen.png',
                        salary: '27~35',
                        salaryUnit: '月収',
                        prefecture: '大阪府',
                        city: '大阪市中央区',
                        image: '/features/ings-20260721/job_card_ramen_03.jpg',
                        href: 'https://foods-labo.com/offers/58960',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ラーメン事業部-3rd',
                    },
                    {
                        offerId: '120933',
                        badgeLabel: 'ラーメン | ホールスタッフ',
                        title: '【月給26万円～＊未経験大歓迎＊人間関係良し】新橋の人気油そば店で社員を募集',
                        brandName: '日本油党 新橋支部',
                        brandLogo: '/features/ings-20260721/logo_ramen.png',
                        salary: '26~34',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '港区',
                        image: '/features/ings-20260721/job_card_ramen_04.jpg',
                        href: 'https://foods-labo.com/offers/120933',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ラーメン事業部-4th',
                    },
                    {
                        offerId: '58992',
                        badgeLabel: 'ラーメン | キッチンスタッフ',
                        title: '《昇給年3回！未経験も歓迎✨》日本油党の社員スタッフ／給与・勤務地相談可',
                        brandName: '日本油党 渋谷総本部',
                        brandLogo: '/features/ings-20260721/logo_ramen.png',
                        salary: '27~35',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '渋谷区',
                        image: '/features/ings-20260721/job_card_ramen_05.jpg',
                        href: 'https://foods-labo.com/offers/58992',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ラーメン事業部-5th',
                    },
                    {
                        offerId: '58991',
                        badgeLabel: 'ラーメン | 店長・店長候補',
                        title: '【店長候補＊月給29万～＊昇給年3回】上場企業が運営する人気油そば専門店',
                        brandName: '日本油党 渋谷総本店',
                        brandLogo: '/features/ings-20260721/logo_ramen.png',
                        salary: '29~43',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '渋谷区',
                        image: '/features/ings-20260721/job_card_ramen_06.jpg',
                        href: 'https://foods-labo.com/offers/58991',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ラーメン事業部-6th',
                    },
                    {
                        offerId: '120936',
                        badgeLabel: 'ラーメン | ホールスタッフ',
                        title: '【未経験歓迎＊転居補助＊月給26万～】家系ラーメンのスタッフ募集｜仙台市内',
                        brandName: '横浜家系ラーメン みどり 仙台広瀬通り店',
                        brandLogo: '/features/ings-20260721/logo_ramen.png',
                        salary: '26~34',
                        salaryUnit: '月収',
                        prefecture: '宮城県',
                        city: '仙台市青葉区',
                        image: '/features/ings-20260721/job_card_ramen_07.jpg',
                        href: 'https://foods-labo.com/offers/120936',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ラーメン事業部-7th',
                    },
                ],
            },
            {
                id: 'cona',
                categoryLabel: 'CONA',
                description:
                    '直径23cmのピザが1枚500円。圧倒的なコスパと、オシャレで気取らない空間が魅力のイタリアンバル。年間5店舗以上の出店計画中。',
                jobs: [
                    {
                        offerId: '120946',
                        badgeLabel: 'イタリアン | 店長・店長候補',
                        title: '【OPEN予定のイタリアンバル＊平塚市】上場企業＊月9日休み＊昇給年3回',
                        brandName: 'CONA 平塚店',
                        brandLogo: '/features/ings-20260721/logo_cona.jpg',
                        salary: '28~41',
                        salaryUnit: '月収',
                        prefecture: '神奈川県',
                        city: '平塚市',
                        image: '/features/ings-20260721/job_card_cona_01.jpg',
                        href: 'https://foods-labo.com/offers/120946',
                        analyticsLabel: 'CT_Jobinformation_求人例-CONA-1st',
                    },
                    {
                        offerId: '120942',
                        badgeLabel: 'イタリアン | ホールスタッフ',
                        title: '《イタリアンバルの正社員募集》未経験歓迎＊月26万〜＊昇給年3回＊月9日休',
                        brandName: 'CONA 田町芝浦店',
                        brandLogo: '/features/ings-20260721/logo_cona.jpg',
                        salary: '26~34',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '港区',
                        image: '/features/ings-20260721/job_card_cona_02.jpg',
                        href: 'https://foods-labo.com/offers/120942',
                        analyticsLabel: 'CT_Jobinformation_求人例-CONA-2nd',
                    },
                    {
                        offerId: '58646',
                        badgeLabel: 'イタリアン | キッチンスタッフ',
                        title: '＼昇給年3回×1回1万円のチャンスあり！／人気イタリアンバル「CONA」',
                        brandName: 'CONA 蒲田店',
                        brandLogo: '/features/ings-20260721/logo_cona.jpg',
                        salary: '26~34',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '大田区',
                        image: '/features/ings-20260721/job_card_cona_03.jpg',
                        href: 'https://foods-labo.com/offers/58646',
                        analyticsLabel: 'CT_Jobinformation_求人例-CONA-3rd',
                    },
                    {
                        offerId: '58641',
                        badgeLabel: 'イタリアン | ホールスタッフ',
                        title: '【未経験歓迎＊上場企業＊月9日休み】人気イタリアンバルの正社員スタッフ募集',
                        brandName: 'CONA 川崎店',
                        brandLogo: '/features/ings-20260721/logo_cona.jpg',
                        salary: '26~34',
                        salaryUnit: '月収',
                        prefecture: '神奈川県',
                        city: '川崎市川崎区',
                        image: '/features/ings-20260721/job_card_cona_04.jpg',
                        href: 'https://foods-labo.com/offers/58641',
                        analyticsLabel: 'CT_Jobinformation_求人例-CONA-4th',
                    },
                ],
            },
            {
                id: 'shumai',
                categoryLabel: '焼売のジョー',
                description:
                    '「焼売を日常に。」がコンセプトの大衆酒場。安くてうまいをテーマに、年齢・性別問わず立ち寄りたくなる新しい大衆居酒屋です。',
                jobs: [
                    {
                        offerId: '71137',
                        badgeLabel: '居酒屋,中華料理・中国料理｜店長・店長候補',
                        title: '【上場企業＊昇給年3回あり】地域一番店を目指す！NEO大衆居酒屋の店長候補',
                        brandName: '焼売のジョー 千葉店',
                        brandLogo: '/features/ings-20260721/logo_jo.jpg',
                        salary: '28~42',
                        salaryUnit: '月収',
                        prefecture: '千葉県',
                        city: '千葉市中央区',
                        image: '/features/ings-20260721/job_card_jo_01.jpg',
                        href: 'https://foods-labo.com/offers/71137',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-焼売のジョー-1st',
                    },
                    {
                        offerId: '58702',
                        badgeLabel:
                            '居酒屋,中華料理・中国料理｜キッチンスタッフ',
                        title: '＼1回1万円昇給チャンス×年3回！／未経験も歓迎のNEO大衆居酒屋！！',
                        brandName: '焼売のジョー 錦糸町店',
                        brandLogo: '/features/ings-20260721/logo_jo.jpg',
                        salary: '26~34',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '墨田区',
                        image: '/features/ings-20260721/job_card_jo_02.jpg',
                        href: 'https://foods-labo.com/offers/58702',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-焼売のジョー-2nd',
                    },
                    {
                        offerId: '58701',
                        badgeLabel: '居酒屋,中華料理・中国料理｜ホールスタッフ',
                        title: '【NEO大衆居酒屋の正社員募集】未経験可＊月26万〜＊月9日休＊昇給年3回',
                        brandName: '焼売のジョー 錦糸町店',
                        brandLogo: '/features/ings-20260721/logo_jo.jpg',
                        salary: '26~34',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '墨田区',
                        image: '/features/ings-20260721/job_card_jo_03.jpg',
                        href: 'https://foods-labo.com/offers/58701',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-焼売のジョー-3rd',
                    },
                    {
                        offerId: '58700',
                        badgeLabel: '居酒屋,中華料理・中国料理｜店長・店長候補',
                        title: '＼店長平均年齢27歳／未経験も歓迎☆年3回昇格チャンスのNEO大衆居酒屋！',
                        brandName: '焼売のジョー 錦糸町店',
                        brandLogo: '/features/ings-20260721/logo_jo.jpg',
                        salary: '28~42',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '墨田区',
                        image: '/features/ings-20260721/job_card_jo_04.jpg',
                        href: 'https://foods-labo.com/offers/58700',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-焼売のジョー-4th',
                    },
                    {
                        offerId: '58770',
                        badgeLabel:
                            '居酒屋,中華料理・中国料理｜キッチンスタッフ',
                        title: '【野毛エリアのネオ大衆居酒屋】昇給年3回＊月9日休み＊未経験OK＊転居補助',
                        brandName: '焼売のジョー 野毛店',
                        brandLogo: '/features/ings-20260721/logo_jo.jpg',
                        salary: '26~34',
                        salaryUnit: '月収',
                        prefecture: '神奈川県',
                        city: '横浜市中区',
                        image: '/features/ings-20260721/job_card_jo_05.jpg',
                        href: 'https://foods-labo.com/offers/58770',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-焼売のジョー-5th',
                    },
                    {
                        offerId: '58768',
                        badgeLabel: '居酒屋,中華料理・中国料理｜ホールスタッフ',
                        title: '＼未経験も歓迎／月給26万円〜☆年3回昇格チャンス有のNEO大衆居酒屋',
                        brandName: '焼売のジョー 野毛店',
                        brandLogo: '/features/ings-20260721/logo_jo.jpg',
                        salary: '26~34',
                        salaryUnit: '月収',
                        prefecture: '神奈川県',
                        city: '横浜市中区',
                        image: '/features/ings-20260721/job_card_jo_06.jpg',
                        href: 'https://foods-labo.com/offers/58768',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-焼売のジョー-6th',
                    },
                    {
                        offerId: '58767',
                        badgeLabel: '居酒屋,中華料理・中国料理｜店長・店長候補',
                        title: '＼店長平均年齢27歳／未経験も歓迎☆年3回昇格チャンスのNEO大衆居酒屋！',
                        brandName: '焼売のジョー 野毛店',
                        brandLogo: '/features/ings-20260721/logo_jo.jpg',
                        salary: '28~42',
                        salaryUnit: '月収',
                        prefecture: '神奈川県',
                        city: '横浜市中区',
                        image: '/features/ings-20260721/job_card_jo_07.jpg',
                        href: 'https://foods-labo.com/offers/58767',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-焼売のジョー-7th',
                    },
                ],
            },
            {
                id: 'hyakutaro',
                categoryLabel: '魚の登竜門\nすしショップ百太郎',
                description:
                    '「旨い魚をこの価格で！？」がモットーの寿司・魚居酒屋。日本酒と魚を楽しめるINGS初の魚業態ブランド。',
                variant: 'list',
                jobs: [
                    {
                        offerId: '88207',
                        badgeLabel: '寿司・鮨｜店長・店長候補',
                        title: '【錦糸町＊寿司居酒屋の店長候補】年3回昇格チャンス＊上場企業＊月9日休み',
                        brandName: '魚の登竜門 すしショップ百太郎 錦糸町店',
                        brandLogo: '/features/ings-20260721/logo_hyakutaro.jpg',
                        salary: '28~42',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '墨田区',
                        image: '/features/ings-20260721/job_card_hyakutaro_01.jpg',
                        href: 'https://foods-labo.com/offers/88207',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-すしショップ百太郎-1st',
                    },
                ],
            },
        ],
    },
}
